import './name.css';

function Name() {
  return (
    <div className="Name mb-3">
      <h1>KELLIE HARMAN</h1>
    </div>
  );
}

export default Name;